import { defineMagic } from '~/scripts/utils/alpine'
import { useClipboard } from '~/scripts/composables/useClipboard'

export default defineMagic((_element, options) =>
  useClipboard(options.Alpine.store('toast')),
)

// Declare $toast as a magic property
declare module 'alpinejs' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface Magics<T> {
    $clipboard: ReturnType<typeof useClipboard>
  }
}
